module.exports = __webpack_public_path__ + "img/delete-datafile.b8a86668.png";